export default __webpack_public_path__ + "static/media/virti-dark-small.54e7a752.svg";